import faqJson from './content/faq.json';

export const faqMock = {
    layoutType: 2,
    data: {
        name: 'faq',
        areasList: [
            {
                id: 1,
                name: 'FAQPage',
                componentName: 'Comp:AccordionFAQ',
                content: JSON.stringify(faqJson)
            }
        ]
    }
};
